import { Injectable } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { AddressBooksQuery } from '../../../models/address-books-query';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class AddressBookFilterService extends FilterService<AddressBooksQuery> implements FilterAssistQuery<AddressBooksQuery> {

    private ADDRESS_BOOK_FILTER = 'ADDRESS_BOOK_FILTER';

    constructor() {
        super();
        this.registerFilters(this);
    }

    protected describe(terms: string): string {
        return $localize`Filter for "${terms}"`;
    }

    active(query: AddressBooksQuery): Observable<FilterAssist[]> {
        if (query.filter) {
            return of([{
                id: this.ADDRESS_BOOK_FILTER,
                description: this.describe(query.filter),
                score: 50,
                parameter: query.filter,
                category: FilterCategoryEnum.ANY
            }]);
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: AddressBooksQuery): void {
        switch (id) {
            case this.ADDRESS_BOOK_FILTER:
                query.filter = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.ADDRESS_BOOK_FILTER ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return of([{
            id: this.ADDRESS_BOOK_FILTER,
            parameter: terms,
            score: 50,
            description: this.describe(terms),
            category: FilterCategoryEnum.ANY
        }]);
    }

    unapply(id: string, query: AddressBooksQuery): void {
        switch (id) {
            case this.ADDRESS_BOOK_FILTER:
                query.filter = null;
                break;
        }
    }
}
